import React from 'react'

export const Contact = () => {
  return (
    <div className='flex flex-col bg-blue-900 gap-4 md:p-24  py-12 justify-center items-center  px-4' id='contact'>
        <h1 className='text-white font-bold text-4xl '>CONTACT</h1>
        <hr className='bg-white w-[160px] h-1 -mt-3'/>
        <span className='text-sky-100 text-sm md:text-lg font-semibold'>I,d love to hear from you-reach out for any opportunity or questions! </span>
        <div className='flex flex-col justify-center items-center border-white border-[2px] p-4 rounded-xl mt-4 md:w-[350px] w-max'>
            <h2 className='font-bold text-xl md:text-2xl text-white mb-2'>Contact With me</h2>
            <form action="" className='flex flex-col gap-3 bg-transparent text-black md:w-[350px] w-max md:px-4'>
                <input type="text" placeholder='Your Name' required className='border-white border-[1px] rounded-lg p-2 bg-inherit text-white ' />
                <input type="email" placeholder='Your Email' required className='border-white border-[1px] rounded-lg p-2 bg-inherit text-white' />
                <input type="text" placeholder='Subject' required className='border-white border-[1px] rounded-lg p-2 bg-inherit text-white' />
                <textarea name="" id="" placeholder='Message' required className='border-white border-[1px] rounded-lg p-2 bg-inherit text-white h-24'></textarea>
                <button className='bg-white md:rounded-2xl rounded-xl md:py-3 py-2 text-blue-800 font-bold  md:text-2xl text-xl'>Send</button>
            </form>
        </div>

    </div>
  )
}
